export const baseURl = process.env.REACT_APP_BASE_URL;
export const authURL = process.env.REACT_APP_BASE_URL;
